<template>
  <router-view />
</template>
<script>
export default {
  name: 'UsersView',
};
</script>
